import { render } from "./message-order.vue?vue&type=template&id=09724a67&scoped=true&ts=true"
import script from "./message-order.vue?vue&type=script&lang=ts"
export * from "./message-order.vue?vue&type=script&lang=ts"

import "./message-order.vue?vue&type=style&index=0&id=09724a67&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09724a67"]])

export default __exports__